const myLoader = ({ src }) => {
    return `/api/uploads/${src}`
}
export default myLoader